/* eslint-disable max-lines */

import { $generateHtmlFromNodes } from '@lexical/html';
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { COMMAND_PRIORITY_NORMAL, KEY_ENTER_COMMAND } from 'lexical';
import * as React from 'react';
import { useEffect } from 'react';

type HookProps = {
  callback: (value: string) => void;
};

const ExecuteOnEnterPlugin: React.FC<HookProps> = ({ callback }): JSX.Element | null => {
  const [editor] = useLexicalComposerContext();

  useEffect(
    () =>
      editor.registerCommand(
        KEY_ENTER_COMMAND,
        () => {
          editor.update(() => {
            const htmlString = $generateHtmlFromNodes(editor);
            callback(htmlString);
          });

          return true;
        },
        COMMAND_PRIORITY_NORMAL
      ),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [editor]
  );

  return null;
};

export default ExecuteOnEnterPlugin;
